export default {
  voucher: {
    title: '嵯峨野トロッコ列車電子乗車票',
    info: {
      voucherNumber: 'チケット番号',
      date: '利用日',
      time: '発車時間',
      serviceName: '列車名',
      userNumber: '乗車人数',
      seat: '座席',
      agentName: '代理店名',
      agentSubGroupName: '営業所名',
      groupName: '団体名',
      tip: '特記事項',
      notice: '注意事項',
      total: '合計 ',
      people: '名',
      station: 'トロッコ',
      seatsTips: `
      詳細は下記座席表を参照願います`,
      noticeValue: `乗車当日は発車20分前までに手続きをお願いします。
        緊急の際は075-871-3997までご連絡をお願いします。
        トロッコ列車は全車指定席。
        全車禁煙です。
        `
    },
    qrCode: {
      title: '二次元バーコード',
      tip: 'チケットの利用方法',
      step1: 'STEP01',
      step1Tip: 'こちらの乗車券をダウンロードする',
      step2: 'STEP02',
      step2Tip: '駅の窓口に発車20分前に受付を完了してください',
      step3: 'STEP03',
      step3Tip: '座席表を確認してお座り下さい'
    },
    carsTitle: '座席表',
    carsTip: '※座席番号が記載されているところが選択されている座席です。',
    arrangementPattern: {
      carName: '車両',
      car1: '1号車',
      car2: '2号車',
      car3: '3号車',
      car4: '4号車',
      car5: 'リッチ号/5号車'
    }
  },
  invoice: {
    title: '請求書',
    paymentType: {
      PREPAID: '(クレジットカード支払い)',
      COUPON: '（船車券発行）',
      MONTHLY: '（銀行振込）',
      CASH: '現金',
      OTHER: 'その他'
    },
    info: {
      title: '{{agentName}} 御中',
      tip: '毎々格別のお引き立てを賜り、誠にありがとうございます。下記の通り、ご請求申し上げます。'
    },
    infoDate: {
      COUPON: 'お支払い期限',
      PREPAID: 'お支払い期限'
    },
    bill: {
      title: 'ご請求金額（税込）',
      people: '人数合計',
      groupType: '団体区分',
      date: '利用日',
      time: '乗車時刻',
      trainName: '列車名'
    },
    table: {
      allAmount: '総額 (1)+(2)（税込）',
      cancelAllAmount: '総額 (2)+(3)（税込）',
      total: '合計',
      allPaidAmount: 'お支払い済額',
      taxDiff: '税率区分',
      tax: '消費税',
      amount: '金額（税込）',
      memo: '備考'
    },
    tax: '消費税額',
    groupType: {
      NORMAL: '一般団体',
      SCHOOL: '学生団体'
    },
    taxDetail: '税金詳細',
    agent: {
      date: '発行日',
      invoiceId: '請求番号',
      corporateNumber: '登録番号',
      postalCode: '〒',
      address: '住所',
      phone: '電話',
      fax: 'FAX'
    }
  },
  seat: {
    parenthesis: '（{{text}}）',
    header: {
      station: '請輸入訂購資訊',
      seat: '請選擇車廂及座位',
      start: '{{time}}出發',
      confirm: '請確認購買資訊',
      orderConfirm: '座位確認',
      orderConfirmTip: '※僅在支付完成且預訂完成後，座位才會正式確認。'
    },
    button: {
      back: '回退',
      next: '下一步'
    },
    selectSeatType: {
      title: '選位方法',
      auto: '電腦選位',
      manual: '自行選位'
    },
    station: {
      date: '乘車日',
      startStation: '出發站',
      endStation: '抵達站',
      startStationTip: '請選擇出發站',
      endStationTip: '請選擇抵達站'
    },
    hintType: {
      OUT_OF_AVAILABLE_TERM:
        '所選日期尚未開放預訂。（僅可預訂1個月內的車次。）',
      END_OF_SERVICE: '本日營運已結束。'
    },
    train: {
      header: '請選擇小火車',
      emptySeat: '空座位'
    },
    carriage: {
      carriage1: '1號車廂',
      carriage2: '2號車廂',
      carriage3: '3號車廂',
      carriage4: '4號車廂',
      carriage5: '富貴5號車廂',
      directionUpTitle: '↑ 往小火車嵯峨站方向',
      directionDownTitle: '↑ 往小火車龜岡站方向'
    },
    baseCar: {
      front: '駕駛室',
      entrance: '入口'
    }
  },
  receipt: {
    title: '領収書',
    name: '御中',
    number: 'No.',
    issueData: '発行日',
    amountTips: '但、嵯峨野トロッコ利用料として\n上記正に領収いたしました。',
    price: '金額',
    priceUnit: '￥{{price}}',
    afterTax: '（税込）',
    afterTaxPrice: '税抜金額',
    taxPrice: '消費税等',
    issuer: `{{name}}\n〒{{postalCode}}\n{{address}}\n電話：{{phoneNumber}}`,
    chargeTips: '※内訳は請求書を参照願います。',
    tips: '＊A4縦に印刷し、下部の余白は切ってお使いください'
  },
  cancellationPolicy: {
    title: 'キャンセルポリシー'
  }
};
